import { Location } from 'history'

export default (location: Location): boolean => {
  return new URLSearchParams(location.search).get('fullscreen') === 'true'
}
